import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class MigrationService {

  constructor(
    private http: HttpClient
  ) { }

  getMigrations(integrationId: string, customerIntegrationId: number, type: string = "", status: string = "") {
    return this.http.get(API_URL + 'migration/' + integrationId + '?hubspotCustomerId=' + customerIntegrationId +
      '&type=' + type + '&status=' + status, { responseType: 'json' });
  }
}
